import { Box, Button, IconButton, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { maxLength, useInput, useTranslate } from 'react-admin';
import { Add, Delete } from '@material-ui/icons';
import { TextInput } from '../../../../base/components/ra/inputs';

const CompanyAddress = ({ disabled }) => {
  const classes = useStyles();
  const t = useTranslate();
  const {
    input: { onChange, value: companyAddress },
  } = useInput({
    source: 'companyAddress',
  });

  return (
    <Box display="flex" flexDirection="column" mb={companyAddress?.length < 2 ? 7 : 0}>
      <Typography variant="h5" className={classes.label}>
        {t('resources.group.fields.companyAddress')}
      </Typography>
      {(companyAddress?.length ? companyAddress : ['']).map((_, index) => (
        <Box
          display="flex"
          alignItems="flex-start"
          sx={{
            gap: 8,
          }}
        >
          <TextInput
            key={index}
            source={`companyAddress[${index}]`}
            label={t('resources.group.fields.addressLine', {
              line: index + 1,
            })}
            validate={[
              maxLength(
                55,
                t('ra.validation.maxLength', {
                  max: 55,
                }),
              ),
            ]}
            disabled={disabled}
            helperText={!disabled}
          />
          {!disabled && (
            <IconButton
              className={classes.removeButton}
              onClick={() => onChange(companyAddress.filter((_, addressLineIdx) => addressLineIdx !== index))}
              size="small"
            >
              <Delete />
            </IconButton>
          )}
        </Box>
      ))}
      {companyAddress?.length < 2 && !disabled && (
        <Button
          className={classes.addButton}
          onClick={() => onChange([...(companyAddress || ['']), ''])}
          startIcon={<Add />}
          variant="outlined"
          color="primary"
        >
          {t('resources.group.addAddressLine')}
        </Button>
      )}
    </Box>
  );
};

export default CompanyAddress;

const useStyles = makeStyles((theme) => ({
  removeButton: {
    color: theme.palette.error.main,
    width: 40,
    height: 40,
    marginTop: 7,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.error[100],
    },
  },
  addButton: {
    margin: 0,
    textTransform: 'math-auto',
  },
  label: {
    color: theme.palette.grey[700],
    fontSize: 16,
    marginBottom: 4,
  },
}));
